import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';

// Extended Appiya Component
import FAQGrid from './components-faq/FAQGrid';

const FAQPage = () => {
  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title="よくあるご質問"
        subtitle="protoAIのサービスについて、お客様から特によくいただくご質問と回答をまとめました"
        breadcrumb="FAQ"
      />

      {/* FAQ詳細 - Appiyaコンポーネント使用 */}
      <FAQGrid data={protoaiData.faq} />
    </div>
  );
};

export default FAQPage;